import { useMediaQuery } from "@mui/material"
import { Input } from "antd"
import { FC, useEffect, useState } from "react"
import { EmbeddingProps } from "../../pages/Embedding/interface"
import { SliderScreenSelect } from "../constant/constant"
import CustomizedColorInput from "../CreateForm/ColorBase"
import CustomizedSingleSelectDropdown from "../CreateForm/DropdownBase"
import CustomizedInput from "../CreateForm/InputBase"
import CustomizedSwitch from "../CreateForm/SwitchBase"
import { EditButton } from "../Custom/Buttons"
import { FontTitleSectionContainer } from "../CustomCss/styled"
import './style.scss'

const initial = {
  mode: "slider",
  position:
    "left",
  buttonText: "click me",
  buttonColor: "#000",
  fontSize: "17",
  borderRadius: "10",
  buttonToText: false
}

interface SliderScreenComponentProps {
  setWidgetConfigDetails: any;
  widgetConfigDetails?: any;
}

type Props = EmbeddingProps & SliderScreenComponentProps;
const SliderScreenComponent: FC<Props> = ({ setWidgetConfigDetails, widgetConfigDetails }) => {
  const [embedData, setEmbedData] = useState(initial)
  const [editColor, setEditColor] = useState(false)
  const isLessThan1440 = useMediaQuery("(max-width:1439px)");

  useEffect(() => {
    setWidgetConfigDetails((prev: any) => {
      return {
        ...prev,
        position: embedData.position,
        buttonText: embedData?.buttonText,
        buttonColor: embedData.buttonColor,
        fontSize: embedData.fontSize.includes("px") ? `${embedData.fontSize}` : `${embedData.fontSize}px`,
        borderRadius: embedData.borderRadius.includes("%") ? `${embedData.borderRadius}` : `${embedData.borderRadius}%`,
        buttonToText: embedData.buttonToText
      }
    })
  }, [embedData])
  useEffect(() => {
    if (widgetConfigDetails?.mode === "slider" && widgetConfigDetails?.position !== undefined && widgetConfigDetails?.buttonText !== undefined && widgetConfigDetails?.buttonColor !== undefined && widgetConfigDetails?.fontSize !== undefined && widgetConfigDetails?.borderRadius !== undefined && widgetConfigDetails?.buttonToText !== undefined) {
      setEmbedData(widgetConfigDetails)
    }
  }, [widgetConfigDetails.id])

  return (
    <div className="sliderScreen">
      <div className="sliderScreenPosition">
        <FontTitleSectionContainer isLargeScreen={!isLessThan1440}>
          Position
        </FontTitleSectionContainer>
        <CustomizedSingleSelectDropdown
          value={embedData.position}
          setValue={(e) => setEmbedData((prev) => ({ ...prev, position: e }))}
          dataProvider={SliderScreenSelect}
        />
      </div>
      <FontTitleSectionContainer isLargeScreen={!isLessThan1440}>
        Button text
      </FontTitleSectionContainer>
      <CustomizedInput
        placeholder=""
        value={embedData.buttonText}
        onChange={(e: any) => setEmbedData((prev) => ({ ...prev, buttonText: e.target.value }))}
        type="text"
      />
      <FontTitleSectionContainer isLargeScreen={!isLessThan1440}>
        Button color
      </FontTitleSectionContainer>
      <div className="sliderScreenButtonColor">
        <div className="sliderScreenButtonColorName">
          <CustomizedColorInput
            open={editColor}
            color={embedData.buttonColor}
            closeHandler={() => setEditColor(false)}
            setColor={(value: any) => {
              setEmbedData((prev) => ({ ...prev, buttonColor: value }))
            }}
          />
          <span>{embedData.buttonColor}</span>
        </div>
        <EditButton onClick={() => setEditColor(true)}
          variant="contained"
          size="small" />
      </div>
      <FontTitleSectionContainer isLargeScreen={!isLessThan1440}>
        Font size(px)
      </FontTitleSectionContainer>
      <div className="sliderScreenFontSize">
        <Input name="fontsize" type="range" min="14" max="32" className="sliderScreenRange"
          onChange={(e) => setEmbedData((prev) => ({ ...prev, fontSize: e.target.value }))}
          value={embedData.fontSize}
        />
        <CustomizedInput
          placeholder=""
          style={{ width: 101 }}
          onChange={(e: any) => setEmbedData((prev) => ({ ...prev, fontSize: e.target.value }))}
          value={embedData.fontSize}
          inputProps={{ min: 14, max: 32 }}
          type="number"
        />
      </div>
      <FontTitleSectionContainer isLargeScreen={!isLessThan1440}>
        Rounded corners(%)
      </FontTitleSectionContainer>
      <div className="sliderScreenBorderRadius">
        <Input type="range" min="0" max="100" name="buttonRadius" className="sliderScreenRange"
          value={embedData.borderRadius}
          onChange={(e) => setEmbedData((prev) => ({ ...prev, borderRadius: e.target.value }))}
        />
        <CustomizedInput
          placeholder=""
          style={{ width: 101 }}
          value={embedData.borderRadius}
          onChange={(e: any) => setEmbedData((prev) => ({ ...prev, borderRadius: e.target.value }))}
          inputProps={{ min: 0, max: 100 }}
          type="number"
        />
      </div>
      <div className="sliderScreenButtonToText">
        <FontTitleSectionContainer isLargeScreen={!isLessThan1440} className="sliderScreenButtonToTextLabel">
          Change button to text
        </FontTitleSectionContainer>
        <CustomizedSwitch
          checked={embedData.buttonToText}
          changeHandler={(e: React.ChangeEvent<HTMLInputElement>) =>
            setEmbedData(prev => ({ ...prev, buttonToText: e.target.checked }))
          }
        />
      </div>
    </div>
  )
}

export default SliderScreenComponent